import { User } from '../_shared/models/user.model';
import { AuthService } from '../auth/auth.service';
import { NavController } from '@ionic/angular';
import { Component, OnInit, inject } from '@angular/core';
import { ThemeService } from '../_core/services/theme.service';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { IS_NEW_UI_FLOW } from '../../environments/environment';
interface menuItem {
  route: string,
  iconName: string,
  iconColor: string,
  label: string,
  show: boolean
}

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: true,
  imports: [TranslateModule, IonicModule, RouterModule, CommonModule],
})
export class MainMenuComponent implements OnInit {
  public authService = inject(AuthService);

  isDarkMode: boolean;
  showAdmin: boolean;

  topItems: menuItem[] = [
    {
      route: '/my-players',
      iconName: 'people',
      iconColor: 'secondary',
      label: 'My players',
      show: true
    },
    {
      route: '/my-teams',
      iconName: 'people-circle',
      iconColor: 'secondary',
      label: 'My teams',
      show: true
    },
    // {
    //   route: '/scorekeeper',
    //   iconName: 'person-add',
    //   iconColor: 'secondary',
    //   label: 'Add Scorekeeper',
    //   show: true
    // },
    {
      route: '/tournaments',
      iconName: 'trophy',
      iconColor: 'secondary',
      label: 'Tournaments',
      show: true
    },
    {
      route: '/leagues',
      iconName: 'trophy',
      iconColor: 'secondary',
      label: 'Team Events',
      show: true
    },
    {
      route: '/college-results',
      iconName: 'trophy',
      iconColor: 'secondary',
      label: 'College Tennis',
      show: true
    }

  ]

  constructor(
    private navCtrl: NavController,
    private themeService: ThemeService,
  ) { }

  async ngOnInit() {
    this.isDarkMode = await this.themeService.getIsDarkTheme();
  }

  toggleDarkMode(ev) {
    const isDarkMode = ev.detail.checked;
    this.themeService.toggleAppTheme(isDarkMode);
  }

  logout() {
    this.authService.logout(localStorage.getItem('device-token'))
      .subscribe(
        async res => {
          localStorage.removeItem('returnTo');
          localStorage.removeItem('token');   
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('cognitoUsername'); 
          // Remove all items that include "isPointByPoint" in the key
          // This is to prevent the scoring type from being set to point by point when the user logs in again
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && key.includes("isPointByPoint")) {
              localStorage.removeItem(key);
            }
          }               
          
          await Preferences.remove({ key: `tie-skipCache` });
          if(IS_NEW_UI_FLOW){
            await this.navCtrl.navigateRoot('/auth');
          } else {
            await this.navCtrl.navigateRoot('/login');
          }
        }
      );
  }



}
